export const AVAILABLE_LOCALE = ['fr', 'en'];
